import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {   
  BaseApiTemplateService,
  Core2Config,
} from '../../shared';
import { PNSSettlementContainerModel } from '../../../../../../models/aggregates/erp/fi-pns-settlement';


@Injectable({
  providedIn: "root",
})
export class PNSSettlementService extends BaseApiTemplateService<PNSSettlementContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-pns-settlement-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-pns-settlement-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-pns-settlement-links';
    this.httpClient = http;
  }
}


